import { useQuery } from 'react-query';

import {
  GetYellowhiveflowProductsQueryParams,
  GetYellowhiveflowProductsResponse,
} from 'wg-api-sdk';
import { PartyType } from '@parties/src/types';
import { wgApi } from '../../../../app/src/features/api/wgApi';

const getYellowhiveFlowsProducts = async ({
  insurance_codes,
  coverage_codes,
}: {
  insurance_codes: string[];
  coverage_codes: string[];
}): Promise<GetYellowhiveflowProductsResponse> => {
  const query: GetYellowhiveflowProductsQueryParams = {
    insurance_codes,
    coverage_codes,
  };
  const { data, isError } = await wgApi.get<GetYellowhiveflowProductsResponse>(
    `/v1/api/yellowhiveflows/products`,
    { query },
  );

  if (isError) throw new Error('Failed to fetch products');
  return data;
};

export const useYellowhiveFlowsProducts = ({
  coverage_codes,
  insurance_codes,
  partyType,
}: {
  coverage_codes: string[];
  insurance_codes: string[];
  partyType: PartyType;
}) => {
  return useQuery(
    ['yellowhive-flows-products', insurance_codes, coverage_codes, partyType],
    () => getYellowhiveFlowsProducts({ insurance_codes, coverage_codes }),
    {
      enabled: !!insurance_codes && !!coverage_codes && !!partyType,
      refetchOnMount: false,
      refetchOnWindowFocus: false,
    },
  );
};
